<template>
    <div>
        <div v-if="!embedded" class="question-area text-left">
        
            <div class="info-area">Question {{currIndex}} of {{totalQuestions}}<span class="timer">Time left - {{minsElapsed() | two_digits}}:{{secsElapsed() | two_digits}}</span></div>
            <br>
            <div>{{ques}}</div><br>

            <div id="editor" v-if="source !== ''" class="code-area">
                
               <codemirror ref="myEditor"
                    :code="getSource"
                    :options="editorOptions">
                </codemirror>

            </div>
            <br>

            <div class="direction">Choose the answer that is most correct</div>

            <div v-for="(option, index) in options" :key="index">

                <div class="answer-option" v-on:click="ansSelected(option, index)">
                    <span v-if="index === buttonClicked" class="option-btn-clicked">{{option}}</span>
                    <span v-else class="option-btn">{{option}}</span>
                </div>
               
            </div> 
        </div>


    </div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/js/bootstrap.min.js"></script>

<script>
import _ from 'lodash'
import firebase from '../services/firebase'
import {codemirror} from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/jsx/jsx.js'
// theme css
import 'codemirror/theme/base16-dark.css'
import 'codemirror/theme/monokai.css'

export default { 
    name: 'QuestionElement',
    components: {
        codemirror
    },
    props: {
        source: String,
        ques: String,
        options: Array,
        currIndex: Number,
        totalQuestions: Number,
        allottedTime: Number,
        offset: Number,
        embedded: Boolean
    },
    data: function() {
        return {
            offTime: this.offset,
            button0Clicked: false,
            button1Clicked: false,
            button2Clicked: false,
            button3Clicked: false,
            buttonClicked: -1,
            selected: '',
            optionClicked: false,
            sourceCopy: this.source,
            code: 'class MyComponent extends React.Component {\n\
    render() {\n\
        return() {\n\
            <div>\n\
            This component sucks\n\
            </div>\n\
        }\n\
    }\n\
}',
            editorOptions: {
        // codemirror options
                tabSize: 2,
                mode: 'text/jsx',
                theme: 'monokai',
                lineNumbers: true,
                readOnly: true,
                cursorBlinkRate: -1,
                refresh: true
            }
        }
    },
    watch: {
        currIndex: function(newVal, oldVal) {
            this.offTime = 0;
            this.$refs.myEditor.refresh();
        }
    },
    computed: {
        getSource: function() {
            return _.replace(this.sourceCopy, /#~/g, '\n');
        }
    },
    mounted: function() {
        window.setInterval(() => {
            //this.now = Math.trunc((new Date()).getTime() / 1000)
            this.offTime++
        }, 1000);
    },
    methods: {
        submitAnswer: function() {
            console.log("answer submitted");
        },
        ansSelected: function(option, index) {
            this.optionClicked = !this.optionClicked;
            this.button0Clicked = false;
            this.button1Clicked = false;
            this.button2Clicked = false;
            this.button3Clicked = false;
            this.buttonClicked = index;
            switch(index) {
                case 0:
                    this.button0Clicked = true;
                    break;

                case 1:
                    this.button1Clicked = true;
                    break;

                case 2:
                    this.button2Clicked = true;
                    break;

                case 3: 
                    this.button3Clicked = true;
                    break;
            }
            this.selected = option;
            this.$emit('checked', this.selected);
            console.log("ans selected is " + this.selected);
        },
        timeUp: function() {
            alert('your time is up, taking you to next question');
            this.$emit('timefinished', this.currIndex, this.totalQuestions);
        },
        secsElapsed: function() {
            //console.log("secs Elapsed is " + (this.countTime - this.now) % 60);
            if (this.allottedTime == this.offTime) {
                this.timeUp();
            }
            return (this.allottedTime - this.offTime) % 60;
        },
        minsElapsed: function() {
            var minsElapsed = Math.trunc((this.allottedTime - this.offTime) / 60);
            var secsElapsed = (this.allottedTime - this.offTime) % 60;
            
            var quiz_slug = this.$route.params.slug;

            return minsElapsed;
            
        }
    },
    filters: {
        two_digits: function(value) {
            if(value.toString().length <= 1)
            {
                return "0" + value.toString();
            }
            return value.toString();
        }
    }
}
</script>


<style scoped>

    .question-area {
        margin-top: 20px;
        margin-bottom: 30px;
        padding-top:30px; 
        padding-bottom:30px; 
        padding-left: 5%;
        padding-right: 5%;
        width:70%;
        border:none;
        font-size: 1rem;
        border-radius: 10px;
        box-shadow: 4px 2px 4px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
        font-family: Avenir;
        cursor:pointer;
        background-color:#fff;
        color:#333;
        display:inline-block;
    }

    .info-area {
        font-size: 0.9rem;
        color: #777;
    }

    .code-area {
        background-color: #000;
        color: #fff;
    }

    .code-img {
        width: 100%;
        height: 340px;
    }

    .every-option {
        margin-right: 20px;
    }

    .option-btn {
        font-size: 0.9rem;
        border: 0.5px solid #ddd;
        border-radius: 10px;
        padding: 10px;
        display: block;
        background-color: #fff;
    }

    .option-btn-clicked {
        font-size: 0.9rem;
        border: 0.5px solid #c8bde9;
        border-radius: 10px;
        padding: 10px;
        display: block;
        background-color: #ebe7f8;
    }

    .option-btn:hover {
        background-color: #eee;
    }

    .option-btn:focus {
        background-color: #eee;
        padding: 10px;
        border-radius: 10px;
    }

    .answer-option-clicked {
        padding-top: 1%;
        padding-bottom: 1%;
    }

    .direction {
        font-size: 0.9rem;
        color: #777;
        margin-top: 2%;
        margin-bottom: 1%;
    }

    .answer-option {
        padding-top: 1%;
        padding-bottom: 1%;
    }

    .timer {
        margin-left: 38%;
    }

</style>
